import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ChessBoard from '../components/ChessBoard';
import config from '../config';

const PostView = () => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const res = await axios.get(`${config.API_URL}/blogs/${slug}`);
                setBlog(res.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching blog:', error);
                setLoading(false);
            }
        };

        fetchBlog();
    }, [slug]);

    // Function to render content with embedded PGN boards
    const renderContentWithPGN = () => {
        if (!blog || !blog.content) return null;

        // Split content by [PGN:X] pattern
        const parts = blog.content.split(/(\[PGN:\d+\])/g);

        return parts.map((part, index) => {
            // Check if this part is a PGN placeholder
            const pgnMatch = part.match(/\[PGN:(\d+)\]/);

            if (pgnMatch) {
                const pgnIndex = parseInt(pgnMatch[1]);
                const pgnData = blog.pgn_data?.[pgnIndex];

                if (pgnData) {
                    return (
                        <div key={index} style={{ margin: '20px 0' }}>
                            <ChessBoard pgnString={pgnData} />
                        </div>
                    );
                }
                // If PGN data not found, show placeholder
                return <p key={index} style={{ color: '#999' }}>[Chess board {pgnIndex}]</p>;
            }

            // Regular content - render as HTML
            return (
                <div
                    key={index}
                    dangerouslySetInnerHTML={{ __html: part }}
                />
            );
        });
    };

    if (loading) {
        return <div className="container">Loading...</div>;
    }

    if (!blog) {
        return <div className="container">Blog post not found</div>;
    }

    return (
        <div className="container">
            <article className="blog-post">
                <h1>{blog.title}</h1>
                <p className="meta">
                    By {blog.author.username} | {new Date(blog.createdAt).toLocaleDateString()}
                </p>
                <div className="content">
                    {renderContentWithPGN()}
                </div>
            </article>
        </div>
    );
};

export default PostView;
